/* Product card from the owner's /shop concept (2026-11-04), with the price kept. The
   --card-padding / --card-radius / --card-aspect variables stay wired for the ?tune=1 tuner. */
.card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  background: var(--st-card-bg, #101015);
  border: 1px solid var(--st-card-line, #24252c);
  border-radius: var(--card-radius, 16px);
  overflow: hidden;
  transition: border-color 0.2s ease;
}

.card:hover {
  border-color: var(--st-orange, #e66630);
}

.art {
  position: relative;
  display: block;
  aspect-ratio: var(--card-aspect, 1 / 1);
  background: linear-gradient(145deg, #eee, #bfc0c5);
  overflow: hidden;
}

.art:focus-visible {
  outline: 2px solid var(--st-focus, #00f59b);
  outline-offset: -2px;
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.imagePlaceholder {
  width: 100%;
  height: 100%;
}

.tag {
  position: absolute;
  top: 12px;
  left: 12px;
  border-radius: 20px;
  padding: 7px 10px;
  font-family: var(--font-dm-sans);
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.5px;
}

.tag[data-tag="sale"] {
  background: #e66630;
  color: #fff;
}

.tag[data-tag="new"] {
  background: #00f59b;
  color: #050607;
}

.tag[data-tag="featured"] {
  background: #111117;
  color: #fff;
}

.body {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: var(--card-padding, 15px);
}

.name {
  margin: 0;
  min-height: 42px;
  font-family: var(--font-dm-sans);
  font-size: 14px;
  font-weight: 700;
  line-height: 1.45;
  color: #f8f8fa;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.price {
  margin: 6px 0 0;
  font-family: var(--font-dm-sans);
  font-size: 13px;
  font-weight: 600;
  color: #f8f8fa;
  font-variant-numeric: tabular-nums;
}

.collection {
  margin: 8px 0 0;
  font-family: var(--font-dm-sans);
  font-size: 11px;
  color: var(--st-muted, #898892);
}

/* Grows so every card's button sits on the same line in a row; never less than 16px. */
.spacer {
  flex: 1;
  min-height: 16px;
}

.view {
  width: 100%;
}

@media (max-width: 760px) {
  .body {
    padding: var(--card-padding, 11px);
  }

  .name {
    font-size: 12px;
    min-height: 35px;
  }
}
